<template>
  <v-container fluid class="page-container">
    <v-toolbar
      flat
      class="toolbar--white action-bar overflow--y"
      :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    >
      <Breadcrumb :routes="breadcrumbItems" />
    </v-toolbar>

    <div class="page-content">
      <v-layout align-center justify-center row class="mt-4">
        <v-flex class="box__content">
          <Title />

          <div v-if="!showForm">
            <RequestInfo />

            <v-divider />

            <HowToRequestInfo @showRequestTokenForm="showForm = true" />
          </div>

          <TokenRequestForm v-else @submittedForm="showForm = false" />
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import Breadcrumb from 'components/Breadcrumb'
import HowToRequestInfo from 'components/tokenRequest/HowToRequestInfo'
import RequestInfo from 'components/tokenRequest/RequestInfo'
import Title from 'components/tokenRequest/Title'
import TokenRequestForm from 'components/tokenRequest/Form'

export default {
  name: 'TokenRequestPage',
  components: {
    Breadcrumb,
    HowToRequestInfo,
    RequestInfo,
    Title,
    TokenRequestForm
  },
  data () {
    return {
      breadcrumbItems: [
        { name: 'TokenRequest', title: this.$t('Views.TokenRequestPage.title') }
      ],
      showForm: false
    }
  },
  computed: {
    ...mapState({
      mainMenuIsOpen: state => state.mainMenu.isOpen
    })
  }
}
</script>

<style lang="scss" scoped>
.page-content {
  background-color: #f6f6f6;
  height: 100%;
}

.box__content {
  border: 1px solid $gray-2;
  max-width: 840px;
  transition: box-shadow 0.26s;
  background-color: #ffffff;
  border-radius: 4px;

  &:hover {
    @media (min-width: 992px) {
      box-shadow: 0 1px 6px rgba(#000, 0.25);
    }
  }
}
</style>
